/** @format */

import React from "react";
import { TTemporaryShift, TTemporarySubshift } from "../../../redux-modules/declarations/maps/shifts";
import moment from "moment";
import { useHistory } from "react-router";
import { Badge, Dropdown, Menu, Tooltip } from "antd";
import { Routes } from "../../../utils/Routes";
import { EditOutlined, MoreOutlined } from "@ant-design/icons";
import { UIText } from "../../ui/Text";
import { BaseColor } from "../../../theme/maps/Colors";

// Raggruppa le sedi omonime (es. 2 sub-shift entrambi su "Palermo" -> "Palermo (×2)")
// e le ordina alfabeticamente, invece di ripetere lo stesso nome più volte in ordine casuale.
const groupAndSortOfficeNames = (subshifts: TTemporarySubshift[]): string[] => {
  const counts: Record<string, number> = {};

  subshifts.forEach(s => {
    const name = s.office.name;
    counts[name] = (counts[name] || 0) + 1;
  });

  return Object.keys(counts)
    .sort((a, b) => a.localeCompare(b, "it"))
    .map(name => (counts[name] > 1 ? `${name} (×${counts[name]})` : name));
};

export const eventsListColumns = [
  {
    title: "Nome",
    dataIndex: "name",
    key: "name",
    showMobile: true
  },
  {
    title: "Sedi",
    dataIndex: "subshifts",
    key: "subshifts",
    showMobile: true,
    //@ts-ignore
    //eslint-disable-next-line react/display-name
    render: (row, event: TTemporaryShift, index) => {
      const subshifts = event.subshifts ?? [];

      if (subshifts.length === 0) return <span>-</span>;

      const officeNames = groupAndSortOfficeNames(subshifts).join(", ");

      if (subshifts.length <= 2) {
        return <span>{officeNames}</span>;
      }

      return (
        <Tooltip title={officeNames}>
          <span>{subshifts.length} sedi</span>
        </Tooltip>
      );
    }
  },
  {
    title: "Data",
    dataIndex: "date",
    key: "date",
    showMobile: true,
    //@ts-ignore
    //eslint-disable-next-line react/display-name
    render: (row, event: TTemporaryShift, index) => {
      const today = moment().startOf("day"); // oggi a mezzanotte
      const eventDate = moment(event.date).startOf("day"); // data evento a mezzanotte

      let badgeStatus: "success" | "error" | "warning" = "warning";
      let badgeText = "";

      if (eventDate.isSame(today)) {
        badgeStatus = "success";
        badgeText = "In corso";
      } else if (eventDate.isBefore(today)) {
        badgeStatus = "error";
        badgeText = "Terminata";
      } else if (eventDate.isAfter(today)) {
        badgeStatus = "warning";
        badgeText = "Futura";
      }

      return (
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <span>{eventDate.format("DD/MM/YYYY")}</span>
          <Badge status={badgeStatus} text={badgeText} />
        </div>
      );
    }
  },
  {
    title: "Posti Totali",
    dataIndex: "max_users_total",
    key: "max_users_total",
    showMobile: true,
    //@ts-ignore
    //eslint-disable-next-line react/display-name
    render: (row, event: TTemporaryShift, index) => {
      const total = (event.subshifts ?? []).reduce((sum, s) => sum + s.max_users, 0);
      return <span>{total}</span>;
    }
  },
  {
    title: "Dipendenti Iscritti",
    dataIndex: "joined_users_total",
    key: "joined_users_total",
    showMobile: true,
    //@ts-ignore
    //eslint-disable-next-line react/display-name
    render: (row, event: TTemporaryShift, index) => {
      const total = (event.subshifts ?? []).reduce((sum, s) => sum + s.joined_users, 0);
      return <span>{total}</span>;
    }
  },
  {
    title: "Azioni",
    dataIndex: "actions",
    key: "actions",
    showMobile: true,
    //@ts-ignore
    // eslint-disable-next-line react/display-name
    render: (text, event, index): JSX.Element => (
      <ActionDropdown text={text} event={event} index={index} />
    ),
  },
];

//@ts-ignore
const ActionDropdown = ({ text, event, index }): JSX.Element => {
  const history = useHistory();

  const menu = (
    <Menu>
      <Menu.Item
        key="1"
        onClick={() => history.push(Routes.turniOccasionaliDetail.replace(":id", event.id))}
        icon={<EditOutlined />}
      >
        Gestisci
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menu}>
        <UIText css={"font-size: 24px; cursor: pointer;"} color={BaseColor}>
          <MoreOutlined />
        </UIText>
      </Dropdown>
    </>
  );
};